var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 8.74996V8.33329C15.8333 5.19079 15.8333 3.61913 14.8567 2.64329C13.88 1.66746 12.3092 1.66663 9.16667 1.66663C6.02417 1.66663 4.4525 1.66663 3.47667 2.64329C2.50083 3.61996 2.5 5.19079 2.5 8.33329V13.3333C2.5 14.8866 2.5 15.6633 2.75333 16.275C2.92085 16.6794 3.1664 17.0469 3.47596 17.3565C3.78552 17.6661 4.15303 17.9116 4.5575 18.0791C5.17 18.3333 5.94667 18.3333 7.5 18.3333M5.83333 5.83329H12.5M5.83333 9.16663H9.16667",
    stroke: "#495057",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 18.3738L10.8846 16.4383C10.8883 16.304 11 16.198 11.1343 16.2014C11.9453 16.2224 12.7562 16.2435 13.5672 16.2645C13.7913 16.2703 13.7953 16.0715 13.8076 15.5981C13.8199 15.1248 12.638 14.6952 12.6812 13.0311C12.7244 11.367 13.9722 10.9098 14.9987 10.9365C16.0252 10.9631 17.1306 11.4814 17.0874 13.1455C17.0442 14.8096 15.8513 15.0433 15.8355 15.6508C15.8197 16.2582 15.818 16.323 16.0079 16.3279C16.8154 16.3489 17.6229 16.3698 18.4303 16.3908C18.5647 16.3943 18.6708 16.506 18.6673 16.6404L18.617 18.5759L10.8333 18.3738Z",
    stroke: "#495057",
    strokeWidth: 1.17255,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditMaster);
export default __webpack_public_path__ + "static/media/Audit Master.79d1a1b7a28fca1fac11954579881661.svg";
export { ForwardRef as ReactComponent };